import { SAMPLE_STOCK_OUTS } from "@/features/consignment-stock-out/data/stockOutDataSource";
import { createFileRoute, redirect } from "@tanstack/react-router";

// Old path: keep links working.
export const Route = createFileRoute("/vendor/stock-out/$stockOutId")({
	beforeLoad: ({ params }) => {
		const stockOutRecord = SAMPLE_STOCK_OUTS.find(
			(candidate) => candidate.stockOutNumber === params.stockOutId,
		);
		if (!stockOutRecord)
			throw redirect({
				to: "/vendor/consignment-stock-out",
				search: true,
				replace: true,
			});
		throw redirect({
			to: "/vendor/consignment-stock-out/$id/detail",
			params: { id: stockOutRecord.stockOutId },
			search: true,
			replace: true,
		});
	},
});
